import './Skill.css'

const Tool = ({image, alt, title, description}) => {
	return (
		<div className='skill-container'>
			<img className='skill-image' src={image} alt={alt}></img>
			<span className='skill-title'>{title}</span>
			<span className='skill-description'>{description}</span>
		</div>
	)
}

export default Tool
